module.exports = __webpack_public_path__ + "static/media/SM-MT1-TRIAL.5516c2ca.mp3";